import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom';

const SkillItem = ({ index, skill: { title, description } }) => {

    const pureTitle = title.toLowerCase().trim();

    const location = useLocation();

    return (
        <Fragment>
        <div className={ location.pathname === '/about' ? `stack-${index+1}` : '' }>
            { pureTitle === 'javascript' &&   <i className="fab fa-js fa-3x"></i> }
            { pureTitle === 'react.js' &&   <i className="fab fa-react fa-3x"></i> }
            { pureTitle === 'node.js' &&   <i className="fab fa-node fa-3x"></i> }
            { pureTitle === 'mern stack' &&   <i className="fab fa-js fa-3x"></i> }
          <h3>{title}</h3>
          { location.pathname === '/' && <p>{description}</p> }
        </div>
        </Fragment>
    )
}

SkillItem.propTypes = {
    skill: PropTypes.object.isRequired,
}

export default SkillItem
